/**
 * Toggles the showPassword state
 * @updated 18/03/2024 - 09:15:00
 * @public
 * @see libs/app/client/register/data-access/src/lib/states/register.state.ts
 */
export class ToggleShowPasswordAction {
  public static readonly type = '[Register] ToggleShowPasswordAction';
}
